// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3j8On","col":"styles_col__3zQNi"};